'use client';
import { useState } from "react";

const PlayButton = ({ size = 60, color = "white", hoverColor = "#e0e0e0" }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <svg 
      viewBox="0 0 60 60" 
      width={size} 
      height={size} 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="cursor-pointer transition-transform duration-200 ease-in-out"
      style={{ transform: isHovered ? 'scale(1.05)' : 'scale(1)' }}
    >
      <g clipPath="url(#clip0_1314_65309)">
        <path 
          d="M26.625 39.375L38.8125 31.5625C39.3958 31.1875 39.6875 30.6667 39.6875 30C39.6875 29.3333 39.3958 28.8125 38.8125 28.4375L26.625 20.625C26 20.2083 25.3646 20.1771 24.7188 20.5312C24.0729 20.8854 23.75 21.4375 23.75 22.1875V37.8125C23.75 38.5625 24.0729 39.1146 24.7188 39.4688C25.3646 39.8229 26 39.7917 26.625 39.375ZM30 55C26.5417 55 23.2917 54.3438 20.25 53.0312C17.2083 51.7188 14.5625 49.9375 12.3125 47.6875C10.0625 45.4375 8.28125 42.7917 6.96875 39.75C5.65625 36.7083 5 33.4583 5 30C5 26.5417 5.65625 23.2917 6.96875 20.25C8.28125 17.2083 10.0625 14.5625 12.3125 12.3125C14.5625 10.0625 17.2083 8.28125 20.25 6.96875C23.2917 5.65625 26.5417 5 30 5C33.4583 5 36.7083 5.65625 39.75 6.96875C42.7917 8.28125 45.4375 10.0625 47.6875 12.3125C49.9375 14.5625 51.7188 17.2083 53.0312 20.25C54.3438 23.2917 55 26.5417 55 30C55 33.4583 54.3438 36.7083 53.0312 39.75C51.7188 42.7917 49.9375 45.4375 47.6875 47.6875C45.4375 49.9375 42.7917 51.7188 39.75 53.0312C36.7083 54.3438 33.4583 55 30 55ZM30 50C35.5833 50 40.3125 48.0625 44.1875 44.1875C48.0625 40.3125 50 35.5833 50 30C50 24.4167 48.0625 19.6875 44.1875 15.8125C40.3125 11.9375 35.5833 10 30 10C24.4167 10 19.6875 11.9375 15.8125 15.8125C11.9375 19.6875 10 24.4167 10 30C10 35.5833 11.9375 40.3125 15.8125 44.1875C19.6875 48.0625 24.4167 50 30 50Z" 
          fill={isHovered ? hoverColor : color}
        />
      </g>
      <defs>
        <clipPath>
          <rect width="60" height="60" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default PlayButton;